import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { PaymentSessionForm } from '@components/Payment/PaymentSessionForm';
import { t } from '@lingui/core/macro';
import { CountryCodeType } from 'noddi-util';
import { useParams, useSearchParams } from 'react-router-dom';

export const PayForBooking = () => {
  const { sessionId } = useParams() as { sessionId: string };
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode') || 'NO';

  return (
    <ContentWrapperCustomerApp title={t`How would you like to pay?`} hideBackButton>
      <PaymentSessionForm sessionId={sessionId} countryCode={countryCode as CountryCodeType} />
    </ContentWrapperCustomerApp>
  );
};
